import { render, staticRenderFns } from "./TransportRequestDetail.vue?vue&type=template&id=f8bcde2a&scoped=true&"
import script from "./TransportRequestDetail.vue?vue&type=script&lang=js&"
export * from "./TransportRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransportRequestDetail.vue?vue&type=style&index=0&id=f8bcde2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bcde2a",
  null
  
)

export default component.exports